import React from 'react';
import './ActionsModal.css';

const ActionsModal = ({ onEvaluateAll, onDeleteEvaluations, onDeleteClippings, onShowSavedSelections, onChangeCategory, canDeleteClippings = true }) => {
  return (
    <div className="actions-menu-modal">
      <button onClick={onEvaluateAll}>Avaliar Todas</button>
      <button onClick={onDeleteEvaluations}>Limpar Avaliação</button>
      {canDeleteClippings && <button onClick={onDeleteClippings}>Excluir Notícias</button>}
      <button onClick={onShowSavedSelections}>Seleções Salvas</button>
      <button onClick={onChangeCategory}>Alterar Categoria</button>
    </div>
  );
};

export default ActionsModal;
